module.exports = __webpack_public_path__ + "static/media/icon-alert-octagon.dc065117.svg";